const STALE_ASSET_MESSAGES = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS',
  'error loading dynamically imported module',
  'Load failed for module script',
]

const VUE_ROUTER_STALE_ASSET_MESSAGES = [
  'Couldn\'t resolve component "default"',
]

const STALE_ASSET_RELOAD_PREFIX = 'vte_stale_asset_reload:'
const STALE_ASSET_RELOAD_TTL_MS = 30_000

export function staleAssetErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message
    if (typeof message === 'string') return message
  }
  return ''
}

function currentPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

function reloadKey(path: string): string {
  return `${STALE_ASSET_RELOAD_PREFIX}${path}`
}

function isRecentReloadMarker(value: string | null): boolean {
  if (!value) return false

  const timestamp = Number(value)
  return Number.isFinite(timestamp) && Date.now() - timestamp < STALE_ASSET_RELOAD_TTL_MS
}

export function hasRecentStaleAssetReload(targetPath?: string): boolean {
  if (typeof window === 'undefined') return false

  try {
    const paths = new Set([targetPath, currentPath()].filter((path): path is string => Boolean(path)))

    for (const path of paths) {
      if (isRecentReloadMarker(window.sessionStorage.getItem(reloadKey(path)))) return true
    }

    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const key = window.sessionStorage.key(i)
      if (key?.startsWith(STALE_ASSET_RELOAD_PREFIX) && isRecentReloadMarker(window.sessionStorage.getItem(key))) {
        return true
      }
    }
  } catch {
    return false
  }

  return false
}

export function isStaleAssetError(error: unknown, targetPath?: string): boolean {
  const message = staleAssetErrorMessage(error)
  if (STALE_ASSET_MESSAGES.some((staleMessage) => message.includes(staleMessage))) return true

  return (
    VUE_ROUTER_STALE_ASSET_MESSAGES.some((staleMessage) => message.includes(staleMessage)) &&
    hasRecentStaleAssetReload(targetPath)
  )
}

export function reloadOnceForStaleAsset(targetPath?: string): boolean {
  if (typeof window === 'undefined') return false

  const reloadPath = targetPath || currentPath()
  const key = reloadKey(reloadPath)

  try {
    if (isRecentReloadMarker(window.sessionStorage.getItem(key))) return false
    window.sessionStorage.setItem(key, String(Date.now()))
  } catch {
    // Private browsing/storage failures should not block recovery.
  }

  window.location.assign(reloadPath)
  return true
}
